import { render, staticRenderFns } from "./PromotionsModal.vue?vue&type=template&id=5c68b288&scoped=true"
import script from "./PromotionsModal.vue?vue&type=script&lang=js"
export * from "./PromotionsModal.vue?vue&type=script&lang=js"
import style0 from "./PromotionsModal.vue?vue&type=style&index=0&id=5c68b288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c68b288",
  null
  
)

export default component.exports